import { REPORTS_SEARCH_INDEX } from 'lib/util/algolia';
import { env } from 'lib/env';
import { classnames } from 'tailwindcss-classnames';
import { SortBy } from 'react-instantsearch-hooks-web';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useSearchDictionary } from '../../util';
import { SearchWrapperProps } from '../../SearchTypes';
import { SortByItem } from 'instantsearch.js/es/connectors/sort-by/connectSortBy';
import { useMemo } from 'react';

interface SearchSortWrapperProps extends SearchWrapperProps {
  sortLabel: string;
}

const transformSortBy = (items: { label: string; value: string }[]): Array<SortByItem> => {
  const reportIndex = REPORTS_SEARCH_INDEX() ?? 'never-match';
  return (items ?? []).filter((x) => x.value.startsWith(reportIndex));
};

const SearchSortWrapper = ({ children, sortLabel }: SearchSortWrapperProps) => {
  return (
    <div className={classnames('flex', 'items-center', 'lg:mb-0', 'sm:mb-2')}>
      <span
        className={classnames(
          'text-blue-navy',
          'text-body',
          'font-medium',
          'mr-6',
          'min-w-[50px]',
          'text-sm',
          'text-black',
          'lg:min-w-0'
        )}
      >
        {sortLabel}
      </span>
      {children}
    </div>
  );
};

const SearchSortWithSearch = () => {
  const dict = useSearchDictionary();
  const { sortNewest, sortNameAsc, sortNameDesc } = dict;
  const items = useMemo(() => {
    const reportsSearchIndex = REPORTS_SEARCH_INDEX();
    return [
      { label: sortNewest, value: `${reportsSearchIndex}_date_desc` },
      { label: sortNameAsc, value: `${reportsSearchIndex}_name_asc` },
      { label: sortNameDesc, value: `${reportsSearchIndex}_name_desc` },
      { label: 'not-shown-default', value: `${env.ALGOLIA_INDEX_NAME}` },
      { label: 'not-shown-date', value: `${env.ALGOLIA_INDEX_NAME}_date_desc` },
    ];
  }, [sortNameAsc, sortNameDesc, sortNewest]);

  return (
    <SearchSortWrapper sortLabel={dict.sort}>
      <SortBy
        classNames={{
          root: classnames('w-full'),
          select: classnames(
            'border',
            'border-gray-spunPearl',
            'rounded-md',
            'p-2',
            'w-full',
            'text-sm',
            'text-black'
          ),
        }}
        transformItems={transformSortBy}
        items={items}
      />
    </SearchSortWrapper>
  );
};

const ReportsSort = () => {
  const { sitecoreContext } = useSitecoreContext();
  const pageEditing = sitecoreContext.pageEditing === true;
  if (pageEditing) {
    const theSortLabel = 'Reports Sort';
    return <SearchSortWrapper sortLabel={theSortLabel} />;
  }
  return <SearchSortWithSearch />;
};

export default ReportsSort;
